import React, { useEffect, useRef } from "react";

const ScrollLink = ({ href, children, ...other }) => {
  const ref = useRef();

  useEffect(() => {
    if (href.startsWith("#")) {
      const id = href.substring(1);
      const clickListener = (e) => {
        e.preventDefault();
        const target = document.getElementById(id);
        if (target) {
          setTimeout(() => {
            target.scrollIntoView({ behavior: "smooth" });
          }, 100);
        }
      };
      const elem = ref.current;
      elem.addEventListener("click", clickListener);
      return () => elem.removeEventListener("click", clickListener);
    }
  }, [href]);

  return (
    <a ref={ref} href={href} {...other}>
      {children}
    </a>
  );
};

export default ScrollLink;
